import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const MatchEventTypesFilter = ({
    loading,
    filters,
    restoreFilterValues,
    options,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='matchEventTypes'
        placeholder='Match event type'
        options={options}
        disabled={loading}
        loading={loading}
        multiple={true}
        search
        setValue={restoreFilterValues(filters, 'matchEventTypes')}
    />
);

MatchEventTypesFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
};

MatchEventTypesFilter.defaultProps = {
    loading: false,
};
